export const BackendPort = '8080';
export const BackendUrl = 'https://ox-challenge.click/api';
export const tLimit = 60;